// removed by extract-text-webpack-plugin
module.exports = {"timelineChart":"antd-pro-charts-timeline-chart-timelineChart"};


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/src/components/Charts/TimelineChart/index.less
// module id = 1079
// module chunks = 0